import SearchBusinessResults from 'components/global/SearchBusinessResults';

const LenderSearchBusinessResults = () => <SearchBusinessResults />;

export default LenderSearchBusinessResults;
